export default ".demo-jing-keyboard {\n    padding-bottom: 300px !important;\n}"